import { Component, OnInit } from '@angular/core';

import { UiIconsList, UiSdgIconsList } from '../../../../ui-icons/src/lib/model/ui-icons.model';

@Component({
  selector: 'sh-icons',
  templateUrl: './icons.component.html',
  styleUrl: './icons.component.scss',
  standalone: false
})
export class IconsComponent implements OnInit {
  providersStr = `
        imports: [
            HttpClientModule,
            ...
            UiIconsModule,
        ],
        providers: [
            {
                provide: UI_ICONS_LANGUAGE_TOKEN,
                useFactory: (languageService) => languageService.current$,
                deps: [LanguageService],
            }
        ],
    `;

  angularJsonStr = `
       "your_app.architect.build.options.assets": [
          ...,
          {
            "glob": "**/*",
            "input": "dist/ui-icons/src/assets",
            "output": "assets/ui-icons/"
          }
       ]
    `;

  sdgIconList: UiSdgIconsList[] = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17
  ];

  iconList: UiIconsList[] = [
    'activity',
    'arrow-back',
    'arrow-forward',
    'arrow-up',
    'arrow-up-in-circle',
    'assigned-activity',
    'attached-file',
    'check',
    'check-in-circle',
    'checkmark',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-right-in-circle',
    'chevron-up',
    'close',
    'close_small',
    'comments',
    'commitment',
    'document',
    'dots',
    'download',
    'eye-hide',
    'eye-show',
    'facebook',
    'file',
    'hint',
    'indicator-down',
    'indicator-up',
    'instagram',
    'interaction-needed',
    'knowledge',
    'linked-in',
    'lock',
    'menu',
    'move',
    'omitted',
    'order-down',
    'order-up',
    'plus',
    'plus-bold',
    'rotate-left',
    'rotate-right',
    'smarthead',
    'templates',
    'translate',
    'twitter',
    'youtube',
    'zoom-in',
    'zoom-out'
  ];

  constructor() {}

  ngOnInit(): void {}
}
